import styled from "styled-components";
import { fontNormal } from "@fdr/static-ui/Typography";
import buildColor from "@fdr/static-ui/ColorPalette";

export const Container = styled.div`
  background: ${buildColor("white", "100")};
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 ${buildColor("blue", "000")};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FooterWrapper = styled.div`
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RunnerNumber = styled.span`
  color: ${buildColor("grey", "800")};
  font-family: ${fontNormal};
  font-size: 12px;
  height: 14px;
`;

export const TopRaceRunnerList = styled.section`
  width: 100%;
`;
